import { Directive, Input } from '@angular/core';

let nextUniqueId = 0;
@Directive({
  selector: 'bll-form-hint',
  host: {
    class: 'bll-form-hint',
    '[attr.id]': 'id',
    // '[class.bll-right]': 'align == "end"',
    // '[attr.align]': 'null',
  },
})
export class BllFormHint {
  /** Whether to align the hint label at the start or end of the line. */
  // @Input() align: 'start' | 'end' = 'start';

  /** Unique ID for the hint. Used for the aria-describedby on the form field control. */
  @Input() id: string = `bll-hint-${nextUniqueId++}`;
}
